"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EticketFooter = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_i18next_1 = require("react-i18next");
const i18nConstants_1 = require("../../../constants/i18nConstants");
const cotopaxi_1 = require("@as/cotopaxi");
const EticketFooter = ({ mainWebShop }) => {
    const { t } = (0, react_i18next_1.useTranslation)(i18nConstants_1.I18N_NAMESPACES.general);
    return ((0, jsx_runtime_1.jsx)(cotopaxi_1.Box, { mobile: { spacing: { marginBottom: 6 } }, children: (0, jsx_runtime_1.jsxs)(cotopaxi_1.Text, { children: [t('eticket.footer'), (0, jsx_runtime_1.jsx)("br", {}), t(`eticket.team.${mainWebShop}`)] }) }));
};
exports.EticketFooter = EticketFooter;
